import { Stack } from '@mui/material';
import DefaultPreparationTime from './default-preparation-time/default-preparation-time.component';
import PreparationTimeCalendar from 'components/kitchen-capacity/preparation-time-calendar/preparation-time-calendar.component';

const PreparationTime = () => {
  return (
    <Stack direction="column" spacing={2} mt={2}>
      <DefaultPreparationTime />
      <PreparationTimeCalendar />
    </Stack>
  );
};

export default PreparationTime;
